import { Listing } from './listing.type';

export const getBranchContactUrl = (listing: Listing) => {
    return listing.listingUris?.contact?.replace('contact', 'details/contact');
};
